// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  IContributionRecordAvailableTaxYearsResponseDto,
  IRecordTaxYearChangeResponseDto,
} from '../models/index';
import {
    IContributionRecordAvailableTaxYearsResponseDtoFromJSON,
    IContributionRecordAvailableTaxYearsResponseDtoToJSON,
    IRecordTaxYearChangeResponseDtoFromJSON,
    IRecordTaxYearChangeResponseDtoToJSON,
} from '../models/index';

export interface GetAvailableContributionRecordTaxYearsRequest {
    postingId: number;
    employeeId: number;
}

export interface GetContributionRecordTaxYearChangeRequest {
    postingId: number;
}

/**
 * ContributionRecordControllerApi - interface
 * 
 * @export
 * @interface ContributionRecordControllerApiInterface
 */
export interface ContributionRecordControllerApiInterface {
    /**
     * Retrieves available for transition record tax years for contribution record
     * @summary Get available for transition contribution record tax years
     * @param {number} postingId 
     * @param {number} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributionRecordControllerApiInterface
     */
    getAvailableContributionRecordTaxYearsRaw(requestParameters: GetAvailableContributionRecordTaxYearsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IContributionRecordAvailableTaxYearsResponseDto>>;

    /**
     * Retrieves available for transition record tax years for contribution record
     * Get available for transition contribution record tax years
     */
    getAvailableContributionRecordTaxYears(requestParameters: GetAvailableContributionRecordTaxYearsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IContributionRecordAvailableTaxYearsResponseDto>;

    /**
     * Retrieves latest record tax year change by posting id
     * @summary Get latest record tax year change
     * @param {number} postingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributionRecordControllerApiInterface
     */
    getContributionRecordTaxYearChangeRaw(requestParameters: GetContributionRecordTaxYearChangeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IRecordTaxYearChangeResponseDto>>;

    /**
     * Retrieves latest record tax year change by posting id
     * Get latest record tax year change
     */
    getContributionRecordTaxYearChange(requestParameters: GetContributionRecordTaxYearChangeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IRecordTaxYearChangeResponseDto>;

}

/**
 * 
 */
export class ContributionRecordControllerApi extends runtime.BaseAPI implements ContributionRecordControllerApiInterface {

    /**
     * Retrieves available for transition record tax years for contribution record
     * Get available for transition contribution record tax years
     */
    async getAvailableContributionRecordTaxYearsRaw(requestParameters: GetAvailableContributionRecordTaxYearsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IContributionRecordAvailableTaxYearsResponseDto>> {
        if (requestParameters['postingId'] == null) {
            throw new runtime.RequiredError(
                'postingId',
                'Required parameter "postingId" was null or undefined when calling getAvailableContributionRecordTaxYears().'
            );
        }

        if (requestParameters['employeeId'] == null) {
            throw new runtime.RequiredError(
                'employeeId',
                'Required parameter "employeeId" was null or undefined when calling getAvailableContributionRecordTaxYears().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['postingId'] != null) {
            queryParameters['posting_id'] = requestParameters['postingId'];
        }

        if (requestParameters['employeeId'] != null) {
            queryParameters['employee_id'] = requestParameters['employeeId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/contribution-requests/records/tax-years`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IContributionRecordAvailableTaxYearsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieves available for transition record tax years for contribution record
     * Get available for transition contribution record tax years
     */
    async getAvailableContributionRecordTaxYears(requestParameters: GetAvailableContributionRecordTaxYearsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IContributionRecordAvailableTaxYearsResponseDto> {
        const response = await this.getAvailableContributionRecordTaxYearsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves latest record tax year change by posting id
     * Get latest record tax year change
     */
    async getContributionRecordTaxYearChangeRaw(requestParameters: GetContributionRecordTaxYearChangeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IRecordTaxYearChangeResponseDto>> {
        if (requestParameters['postingId'] == null) {
            throw new runtime.RequiredError(
                'postingId',
                'Required parameter "postingId" was null or undefined when calling getContributionRecordTaxYearChange().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['postingId'] != null) {
            queryParameters['posting_id'] = requestParameters['postingId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/contribution-requests/records/tax-years-change`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IRecordTaxYearChangeResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieves latest record tax year change by posting id
     * Get latest record tax year change
     */
    async getContributionRecordTaxYearChange(requestParameters: GetContributionRecordTaxYearChangeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IRecordTaxYearChangeResponseDto> {
        const response = await this.getContributionRecordTaxYearChangeRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
